<template>
    <b-container>
        <b-row>
            <b-col lg="6" class="my-1">    
            <b-form-group
                  label="Filtrar"
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="filterInput"
                  class="mb-0"
            >
                <b-input-group size="sm">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      placeholder="Escriba para filtrar"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
            </b-col>

            <b-col sm="5" md="6" class="my-1">
                <b-form-group
                  label="Por página"
                  label-cols-sm="6"
                  label-cols-md="6"
                  label-cols-lg="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="perPageSelect"
                  class="mb-0"
                >
                  <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
            </b-form-group>
            </b-col>
        </b-row>

        <b-table 
            striped hover 
            responsive
            sticky-header="400px"

            :items="items" 
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"

            :filter="filter"
            :filterIncludedFields="filterOn"
            @filtered="onFiltered"

            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"

            >
          

            <template v-slot:cell(url)="row">
            
            <b-form-checkbox v-model="row.detailsShowing" @change="row.toggleDetails">
                ver detalles
            </b-form-checkbox>
        </template>
        <template v-slot:row-details="row">
            <b-card>
                <ul v-for="(url, key) in urls" :key="key"><!--row.item -->
                 <li v-if=" url.idsolicitud == row.item.id" >
                   
                    <b-link :href="url.link" target="_blank">{{url.link}}</b-link>
                 </li>
                </ul>
            </b-card>
        </template>


        </b-table>
        <b-row  class="text-center">
        <b-col></b-col>
        <b-col cols="6">
            <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
        </b-col>
        <b-col></b-col>
        </b-row>  
  
    </b-container>
</template>

<script>
 import {mapActions,mapMutations} from 'vuex'
 import userForm from '@/components/admin/userForm'
  import validateMixin from '@/mixins/validation' //para usar el mixin de vee-validate
    export default {
        components:{
            userForm
        },  
        mixins : [validateMixin],
        props:{
            items:{
                type: Array,
                required: true
            },
            fields:{
                type: Array,
                required:true
            },
            urls:{
                type: Array,
                required: true
            }
        },
        data:function(){
            return{
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 50, 100],
                filter:'',
                filterOn: [],
                totalRows: '',
                
                sortBy: 'id',
                sortDesc: true,
            }
               
        },
        created(){
            
        },
        mounted(){
            let self = this
            this.totalRows = self.items.length
            console.log(self.items) 
        },
        methods:{
            
            
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            }
        }
        
    }
</script>

<style lang="scss" scoped>

</style>